export const DEAL_STATUS_LABELS = {
  pending: "Очікує",
  in_progress: "В процесі",
  closed: "Закрита",
  cancelled: "Скасована",
};

export const getDealStatusLabel = (status) =>
  DEAL_STATUS_LABELS[status] || status || "—";
